import { render, staticRenderFns } from "./previewStep.vue?vue&type=template&id=0bf5b85c"
import script from "./previewStep.vue?vue&type=script&lang=js"
export * from "./previewStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports